import "./hours.js";
import "#/shared/api/api-host-global.js";
import "./special_hours.js";
import "./badge.js";
import "./notes.js";

AddressAvailability.Status.Views.Widget = class Widget extends Backbone.View {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.toggleContent = this.toggleContent.bind(this);
    this.setStatusData = this.setStatusData.bind(this);
    this.setUpNextFetch = this.setUpNextFetch.bind(this);
    this.fetchData = this.fetchData.bind(this);
  }

  initialize(options = {}) {
    this.options = options;
    this.hoursView = new AddressAvailability.Status.Views.Hours({ model: this.model });
    this.badgeView = new AddressAvailability.Status.Views.Badge({ model: this.model });
    this.specialHoursView = new AddressAvailability.Status.Views.SpecialHours({ model: this.model });
    this.notesView = new AddressAvailability.Status.Views.Notes({ model: this.model });

    jQuery(this.hoursView.el).hide();
    this.setStatusData();

    // BEHAVIOUR
    this.$el.on("click", () => this.toggleContent());
    this.listenTo(this.model, "change:staleAt", this.setUpNextFetch);
    return this.listenTo(this.model, "change:staleAt", this.render);
  }

  // RENDERING

  render() {
    this.$el.html([this.badgeView.el, this.hoursView.el, this.notesView.el, this.specialHoursView.el]);
    return this;
  }

  toggleContent() {
    jQuery(this.hoursView.el).toggle();
    return jQuery(this.badgeView.el).toggleClass("content-expanded");
  }

  // PRIVATE

  setStatusData() {
    return this.fetchData().then((statusData) => {
      let staleAt;
      if (statusData.open === null) {
        return;
      } else if (statusData.open) {
        staleAt = statusData.nextClosedAt;
      } else {
        staleAt = statusData.nextOpenAt;
      }

      return this.model.set({
        open: statusData.open,
        staleAt,
        nextOpenAt: statusData.nextOpenAt,
        nextClosedAt: statusData.nextClosedAt,
        hours: statusData.hours,
        specialHours: statusData.specialHours,
        note: statusData.note,
        specialNote: statusData.specialNote,
      });
    });
  }

  // FETCH HELPERS

  setUpNextFetch() {
    clearInterval(this.timeoutId);
    const staleAt = moment.parseZone(this.model.get("staleAt"));

    return (this.timeoutId = setTimeout(() => this.setStatusData(), staleAt.diff(moment())));
  }

  // HELPERS

  fetchData() {
    return jQuery.getJSON(this.addressMetadataEndpoint.replace("%{addressId}", this.model.get("addressId")));
  }
};
AddressAvailability.Status.Views.Widget.prototype.tagName = "section";
AddressAvailability.Status.Views.Widget.prototype.className = "address-availability-container";

AddressAvailability.Status.Views.Widget.prototype.addressMetadataEndpoint = window.Sparkle.apiHost
  ? window.Sparkle.apiHost + window.SparkleConfig.routes.embed.addressAvailability.replace("ADDRESS_ID", "%{addressId}")
  : undefined;
